import React, { useContext } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard/dashboard.student';
import PageNotFound from './pages/pagenotfound';
import Settings from './settings/settings.student';
import PracticePlaceProfilePageStudent from './practiceplaces/practiceplaceprofile/practiceplaceprofilepage.student';
import { PrivacyPolicyLoggedIn } from './policy/rightsandprivacy';
import {
  AboutAnalyticsPageLoggedIn,
  AboutCookiesPageLoggedIn,
} from './login/about';
import StudentUserGodtaBetingelserPage from './policy/godtabetingelserpage.student';
import { StudentUserContext } from './user/StudentUserStore';
import Praksissteder from './practiceactivity/praksissteder.student';
import ActivityPage from './practiceactivity/activity.student';

const TopRoutesStudent = () => {
  const { studentUser } = useContext(StudentUserContext);

  if (studentUser && !studentUser.innstillinger.harGodtattBetingelser) {
    return <StudentUserGodtaBetingelserPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/activity/:id" element={<Outlet />}>
        <Route path="" element={<ActivityPage />} />
        <Route path="praksissteder" element={<Praksissteder />} />
      </Route>
      <Route path="/settings" element={<Settings />} />
      <Route
        path="/practiceplaces/profile/:id"
        element={<PracticePlaceProfilePageStudent />}
      />
      <Route path="/policy" element={<PrivacyPolicyLoggedIn />} />
      <Route path="/cookies" element={<AboutCookiesPageLoggedIn />} />
      <Route path="/analytics" element={<AboutAnalyticsPageLoggedIn />} />
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
  );
};

export default TopRoutesStudent;
